import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { A, H1, H3, Input, ContentHolder, SupportNumber } from "commons";
import { clearData } from "commons/src/reducers/indexActions";

function ErrorComponent({ dispatch }) {
    useEffect(() => {
        dispatch(clearData());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const reload = () => {
        location.replace("./index.html");
    };

    return (
        <ContentHolder>
            <H1>Oops!</H1>
            <H3 secondary textAlign="center">
                Looks like something went wrong here. <br />
                Please contact us by phone on <SupportNumber /> between 8:30am and 5:30pm <br />
                or email us at{" "}
                <A href="mailto:client.relations@nucleusfinancial.com">
                    client.relations@nucleusfinancial.com
                </A>
                <br />
                and we’ll see what we can do to help
            </H3>

            <p>
                <Input onClick={reload} type="submit" value="Refresh" textAlign="center" />
            </p>
        </ContentHolder>
    );
}

ErrorComponent.propTypes = {
    dispatch: PropTypes.func
};

export const Error = connect(null)(ErrorComponent);
